import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import { get_faq_by_division } from "../../Axios";
import { get_day_timestamp } from "../../Validation";

interface FaqObject {
  ablack_faq_ID : number;
  ablack_faq_answer : string;
  ablack_faq_division : number;
  ablack_faq_division_name : string;
  ablack_faq_modified : any;
  ablack_faq_question : string;
  ablack_faq_registe : any;
  ablack_faq_status : number;
}

const FAQ: React.FC = () => {
  const [faqDivision, setFaqDivision] = useState<number>(1);
  const [faqList, setFaqList] = useState<FaqObject[]>([]);
  useEffect(() => {
    get_faq_by_division(
      faqDivision
    ).then(result => {
      setFaqList(result);
    });
  }, [faqDivision]);
  return (
    <S.SectionWidth $width={1080}>
      <S.SectionTitleBox>
        <h1>FAQ</h1>
        <h3>A.Black의 자주 묻는 질문을 확인할 수 있습니다.</h3>
      </S.SectionTitleBox>

      <S.FAQCategoryBox>
        <S.FAQCategoryButton
          $active={faqDivision === 1 ? true : false}
          onClick={() => setFaqDivision(1)}
        >
          견적
        </S.FAQCategoryButton>
        <S.FAQCategoryButton
          $active={faqDivision === 2 ? true : false}
          onClick={() => setFaqDivision(2)}
        >
          서비스
        </S.FAQCategoryButton>
        <S.FAQCategoryButton
          $active={faqDivision === 3 ? true : false}
          onClick={() => setFaqDivision(3)}
        >
          회원정보
        </S.FAQCategoryButton>
        <S.FAQCategoryButton
          $active={faqDivision === 4 ? true : false}
          onClick={() => setFaqDivision(4)}
        >
          AP포인트
        </S.FAQCategoryButton>
        <S.FAQCategoryButton
          $active={faqDivision === 5 ? true : false}
          onClick={() => setFaqDivision(5)}
        >
          제품
        </S.FAQCategoryButton>
      </S.FAQCategoryBox>

      <S.ReservationTableHead className="mt-[13px]">
        <div className="w-[110px]">구분</div>
        <div className="w-[300px]">질문</div>
        <div className="w-[440px]">답변</div>
        <div className="w-[110px]">등록일</div>
      </S.ReservationTableHead>

      {faqList.map((tmp, idx) =>
        <div key={tmp.ablack_faq_ID}>
          <S.ReservationTableBody $withBtn={false}>
            <div className="w-[110px]">
              {tmp.ablack_faq_division_name}
            </div>
            <div className="w-[300px]">
              {tmp.ablack_faq_question}
            </div>
            <div className="w-[440px] text-ellipsis whitespace-nowrap overflow-x-hidden">
              {tmp.ablack_faq_answer}
            </div>
            <div className="w-[110px]">
              {get_day_timestamp(tmp.ablack_faq_registe).year_month_day}
            </div>
          </S.ReservationTableBody>
        </div>
      )}
    </S.SectionWidth>
  )
};

export default FAQ;